import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
class VendorsList extends React.Component {
  state = {
    Vendors_List: [],
  }
  componentDidMount() {
    this.getVendorLists()
  }
  getVendorLists = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/admin/list-vendors', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Vendors_List: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  // handleStatusChange = async (id, isActive) => {
  //     var data = {
  //         "userId": id,
  //         "is_active": isActive,
  //     }
  //     await axios.post(Constant.getAPI() + "/user/update-user", data, {
  //         headers: {
  //             "Content-Type": "application/json",
  //             "Authorization": `Bearer ${localStorage.getItem('loged_In_auth')}`,
  //    "country_short_name": `${localStorage.getItem('countryShortName')}`
  //         }
  //     }).then((res) => {
  //         if (res.status === 200) {
  //             Swal.fire("Updated !", "Status has been Changed", "success");
  //             this.dashbord();
  //         }
  //     }).catch((err) => {
  //         this.setState({ isData: false })
  //         if (err?.response?.status === 401) {
  //             Constant.getAuthLogout();
  //         }
  //         else {
  //             Swal.fire({
  //                 title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
  //                 icon: "error",
  //                 text: "",
  //                 type: "error",
  //                 confirmButtonColor: "#3085d6",
  //                 cancelButtonColor: "#d33",
  //                 confirmButtonText: "Ok",
  //             });
  //         }
  //     });
  // };
  render() {
    const columns = [
      {
        name: 'vendorName',
        label: 'Name',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'vendorRole',
        label: 'Role',
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: 'vendorCode',
        label: 'Code Supplier',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={'/vendor/add/' + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Vendors Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Vendors List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Vendors List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Vendors List'}
                          className="table-responsive"
                          data={this.state.Vendors_List}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default VendorsList
